import { computed, ref } from "vue";

export default () => {
  const line_1 = ref(null);
  const line_2 = ref(null);
  const city = ref(null);
  const state = ref(null);
  const zip_code = ref(null);
  const is_valid = computed(() => line_1.value && city.value && state.value && zip_code.value)
  const clear_address = function () {
    line_1.value = null;
    line_2.value = null;
    city.value = null;
    state.value = null;
    zip_code.value = null;
  }
  return {
    line_1,
    line_2,
    city,
    state,
    zip_code,
    is_valid,
    clear_address
  }
}
